enum MovieDetailActionType {
  FETCH_MOVIE_DETAIL_REQUEST = 'FETCH_MOVIE_DETAIL_REQUEST',
  FETCH_MOVIE_DETAIL_REQUEST_SUCCESS = 'FETCH_MOVIE_DETAIL_REQUEST_SUCCESS',
  FETCH_MOVIE_DETAIL_REQUEST_ERROR = 'FETCH_MOVIE_DETAIL_REQUEST_ERROR',
}

export default MovieDetailActionType
